import { Union, Record } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { Role, Role__ToLabel, CompletedTask_$reflection, EnrolledTrack_$reflection, Event$_$reflection, AdminPanelStats_$reflection } from "./Shared/SharedModels.jsx";
import { string_type, union_type, record_type, class_type, int32_type, array_type, option_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { UserAutomationCountdown_$reflection } from "./Shared/RuleModels.jsx";
import { ofArray as ofArray_1, empty } from "./fable_modules/fable-library-js.4.29.0/Set.js";
import { int32ToString, equals, createObj, comparePrimitives } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { createElement } from "react";
import React from "react";
import { utcNow, op_Subtraction, compare, now as now_1, hour } from "./fable_modules/fable-library-js.4.29.0/Date.js";
import { Title2, Badge, Tooltip, Link, SkeletonItem, Skeleton, Body1, Subtitle1, Body1Strong, Caption1, Title3, Card, Caption1Strong, tokens } from "@fluentui/react-components";
import { unwrap, defaultArg } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "./fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { tryHead, empty as empty_1, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { max } from "./fable_modules/fable-library-js.4.29.0/Double.js";
import { sortByDescending, truncate, mapIndexed, map, sumBy } from "./fable_modules/fable-library-js.4.29.0/Array.js";
import { printf, toText, join } from "./fable_modules/fable-library-js.4.29.0/String.js";
import { RouterModule_encodeParts } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { TimerRegular, CircleFilled, PeopleCommunityRegular, CalendarLtrRegular, TaskListLtrRegular, BookOpenRegular, PeopleRegular } from "@fluentui/react-icons";
import { Enrolled } from "./Track/TrackCard.jsx";
import { formatTimeDiff } from "./Helpers.jsx";
import { totalDays } from "./fable_modules/fable-library-js.4.29.0/TimeSpan.js";
import { nb } from "date-fns/locale";
import { format as format_1 } from "date-fns";
import { tap, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.29.0/Async.js";
import { Home, toastServerError, Rule, Task, Track, Event$ } from "./ApiClient.jsx";
import { Result_DefaultValue } from "./fable_modules/fable-library-js.4.29.0/Result.js";
import { errorToast } from "./Toasts.jsx";
import { useCtx } from "./Context.jsx";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { AgendaSection } from "./Event/UpcomingEvents.jsx";
import { NotificationListInline } from "./Notification.jsx";

class Model extends Record {
    constructor(AdminPanel, UpcomingEvents, AttendedEventIds, UserTracks, UserCompletedTasks, MyAutomationCountdowns) {
        super();
        this.AdminPanel = AdminPanel;
        this.UpcomingEvents = UpcomingEvents;
        this.AttendedEventIds = AttendedEventIds;
        this.UserTracks = UserTracks;
        this.UserCompletedTasks = UserCompletedTasks;
        this.MyAutomationCountdowns = MyAutomationCountdowns;
    }
}

function Model_$reflection() {
    return record_type("Home.Model", [], Model, () => [["AdminPanel", option_type(AdminPanelStats_$reflection())], ["UpcomingEvents", array_type(Event$_$reflection())], ["AttendedEventIds", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [int32_type])], ["UserTracks", array_type(EnrolledTrack_$reflection())], ["UserCompletedTasks", array_type(CompletedTask_$reflection())], ["MyAutomationCountdowns", array_type(UserAutomationCountdown_$reflection())]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateAdminPanel", "UpdateEvents", "UpdateAttendedEventIds", "UpdateUserTracks", "UpdateCompletedTasks", "UpdateAutomationCountdowns"];
    }
}

function Msg_$reflection() {
    return union_type("Home.Msg", [], Msg, () => [[["Item", option_type(AdminPanelStats_$reflection())]], [["Item", array_type(Event$_$reflection())]], [["Item", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [int32_type])]], [["Item", array_type(EnrolledTrack_$reflection())]], [["Item", array_type(CompletedTask_$reflection())]], [["Item", array_type(UserAutomationCountdown_$reflection())]]]);
}

function update(m, _arg) {
    switch (_arg.tag) {
        case 1:
            return new Model(m.AdminPanel, _arg.fields[0], m.AttendedEventIds, m.UserTracks, m.UserCompletedTasks, m.MyAutomationCountdowns);
        case 2:
            return new Model(m.AdminPanel, m.UpcomingEvents, _arg.fields[0], m.UserTracks, m.UserCompletedTasks, m.MyAutomationCountdowns);
        case 3:
            return new Model(m.AdminPanel, m.UpcomingEvents, m.AttendedEventIds, _arg.fields[0], m.UserCompletedTasks, m.MyAutomationCountdowns);
        case 4:
            return new Model(m.AdminPanel, m.UpcomingEvents, m.AttendedEventIds, m.UserTracks, _arg.fields[0], m.MyAutomationCountdowns);
        case 5:
            return new Model(m.AdminPanel, m.UpcomingEvents, m.AttendedEventIds, m.UserTracks, m.UserCompletedTasks, _arg.fields[0]);
        default:
            return new Model(_arg.fields[0], m.UpcomingEvents, m.AttendedEventIds, m.UserTracks, m.UserCompletedTasks, m.MyAutomationCountdowns);
    }
}

function init() {
    return new Model(undefined, [], empty({
        Compare: comparePrimitives,
    }), [], [], []);
}

function customDivider(color) {
    return createElement("div", {
        style: {
            width: 1,
            flexGrow: 1,
            backgroundColor: color,
        },
    });
}

function greetingPrefix() {
    const h = hour(now_1()) | 0;
    if (h < 5) {
        return "God natt";
    }
    else if (h < 10) {
        return "God morgen";
    }
    else if (h < 17) {
        return "God dag";
    }
    else {
        return "God kveld";
    }
}

function roleColor(_arg) {
    switch (_arg.tag) {
        case 2:
            return tokens.colorPaletteMarigoldForeground1;
        case 3:
            return tokens.colorPaletteRoyalBlueBorderActive;
        case 1:
            return tokens.colorPaletteBerryForeground1;
        default:
            return tokens.colorBrandBackground;
    }
}

function SectionTitle(sectionTitleInputProps) {
    let elems, el;
    const action = sectionTitleInputProps.action;
    const title = sectionTitleInputProps.title;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 12,
    }], (elems = [(el = Caption1Strong, createElement(el, {
        style: {
            textTransform: "uppercase",
            color: tokens.colorNeutralForeground3,
        },
        children: title,
    })), defaultArg(action, defaultOf())], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function LinkAction(linkActionInputProps) {
    let elems, el;
    const href = linkActionInputProps.href;
    const label = linkActionInputProps.label;
    return createElement("a", createObj(ofArray([["href", href], ["style", {
        textDecoration: "none",
        display: "inline-flex",
        alignItems: "center",
        gap: 4 + "px ",
        padding: ((6 + "px ") + 10) + "px",
        minHeight: 32,
        borderRadius: 4,
        color: tokens.colorBrandForeground1,
    }], (elems = [(el = Caption1Strong, createElement(el, {
        children: label,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function AdminKpi(adminKpiInputProps) {
    let elems_3, elems_2, el, elems_1, el_2, el_4;
    const sub = adminKpiInputProps.sub;
    const value = adminKpiInputProps.value;
    const label = adminKpiInputProps.label;
    const icon = adminKpiInputProps.icon;
    const subtle = adminKpiInputProps.subtle;
    const accent = adminKpiInputProps.accent;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const el_6 = Card;
    return createElement(el_6, createObj(ofArray([["style", createObj(toList(delay(() => append(isMobile ? append(singleton(["padding", 12]), delay(() => singleton(["borderRadius", 8]))) : singleton(["padding", ((16 + "px ") + 18) + "px"]), delay(() => append(singleton(["flexGrow", 1]), delay(() => append(singleton(["flexDirection", "row"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => singleton(["gap", (isMobile ? 10 : 14) + "px "]))))))))))))], (elems_3 = [createElement("div", {
        style: createObj(toList(delay(() => {
            const size = (isMobile ? 30 : 38) | 0;
            return append(singleton(["width", size]), delay(() => append(singleton(["height", size]), delay(() => append(singleton(["borderRadius", ~~(size / 2)]), delay(() => append(singleton(["backgroundColor", subtle]), delay(() => append(singleton(["color", accent]), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => append(singleton(["justifyContent", "center"]), delay(() => singleton(["flexShrink", 0])))))))))))))))));
        }))),
        children: reactApi.Children.toArray([icon]),
    }), createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
        minWidth: 0,
    }], (elems_2 = [(el = Caption1Strong, createElement(el, {
        style: {
            textTransform: "uppercase",
            letterSpacing: "0.6px",
            color: tokens.colorNeutralForeground3,
        },
        children: label,
    })), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(isMobile ? append(singleton(["flexDirection", "column"]), delay(() => append(singleton(["alignItems", "flex-start"]), delay(() => singleton(["gap", 0 + "px "]))))) : append(singleton(["alignItems", "baseline"]), delay(() => singleton(["gap", 6 + "px "]))), delay(() => singleton(["marginTop", 2]))))))))], (elems_1 = [(el_2 = Title3, createElement(el_2, {
        children: int32ToString(value),
    })), (el_4 = Caption1, createElement(el_4, {
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: sub,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])));
}

function Panel(panelInputProps) {
    let elems_2, elems_1, elems;
    const body = panelInputProps.body;
    const action = panelInputProps.action;
    const hint = panelInputProps.hint;
    const title = panelInputProps.title;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const el_4 = Card;
    return createElement(el_4, createObj(ofArray([["style", createObj(toList(delay(() => append(isMobile ? singleton(["padding", ((12 + "px ") + 14) + "px"]) : singleton(["padding", ((16 + "px ") + 18) + "px"]), delay(() => singleton(["flexDirection", "column"]))))))], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "baseline",
        justifyContent: "space-between",
        gap: 10 + "px ",
        marginBottom: 12,
    }], (elems_1 = [createElement("div", createObj(singleton_1((elems = toList(delay(() => {
        let el;
        return append(singleton((el = Body1Strong, createElement(el, {
            children: title,
        }))), delay(() => {
            let el_2;
            return (hint.length > 0) ? singleton((el_2 = Caption1, createElement(el_2, {
                style: {
                    display: "block",
                    color: tokens.colorNeutralForeground3,
                    marginTop: 2,
                },
                children: hint,
            }))) : empty_1();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])))), defaultArg(action, defaultOf())], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), body], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
}

function RoleBar(roleBarInputProps) {
    let elems_3, elems, elems_2;
    const roles = roleBarInputProps.roles;
    const total = max(1, sumBy((_arg) => _arg.Count, roles, {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    })) | 0;
    return createElement("div", createObj(singleton_1((elems_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        height: 8,
        borderRadius: 4,
        overflow: "hidden",
        backgroundColor: tokens.colorNeutralBackground3,
        border: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke1,
    }], (elems = ofArray(map((r) => createElement("div", {
        style: {
            width: ((r.Count / total) * 100) + "%",
            backgroundColor: roleColor(r.Role),
        },
    }), roles)), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
        display: "grid",
        gridTemplateColumns: join(" ", [1 + "fr", 1 + "fr"]),
        columnGap: 14 + "px",
        rowGap: 6 + "px",
        marginTop: 10,
    }], (elems_2 = ofArray(map((r_1) => {
        let elems_1, el, el_2;
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            gap: 8 + "px ",
            fontSize: 12 + "px",
        }], (elems_1 = [createElement("div", {
            style: {
                width: 8,
                height: 8,
                borderRadius: 2,
                backgroundColor: roleColor(r_1.Role),
                flexShrink: 0,
            },
        }), (el = Caption1, createElement(el, {
            style: {
                flexGrow: 1,
                color: tokens.colorNeutralForeground2,
            },
            children: Role__ToLabel(r_1.Role),
        })), (el_2 = Caption1Strong, createElement(el_2, {
            children: int32ToString(r_1.Count),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }, roles)), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))]))));
}

function MiniStat(miniStatInputProps) {
    let elems, el, el_2;
    const withDivider = miniStatInputProps.withDivider;
    const color = miniStatInputProps.color;
    const value = miniStatInputProps.value;
    const label = miniStatInputProps.label;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    return createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => (isMobile ? append(singleton(["display", "inline-flex"]), delay(() => append(singleton(["alignItems", "baseline"]), delay(() => singleton(["gap", 6 + "px "]))))) : append(singleton(["flexGrow", 1]), delay(() => (withDivider ? append(singleton(["borderLeft", (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke3]), delay(() => singleton(["paddingLeft", 14]))) : empty_1())))))))], (elems = [(el = Caption1Strong, createElement(el, {
        style: {
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            color: defaultArg(color, tokens.colorNeutralForeground3),
        },
        children: label,
    })), (el_2 = Subtitle1, createElement(el_2, {
        style: createObj(toList(delay(() => append(!isMobile ? append(singleton(["display", "block"]), delay(() => singleton(["marginTop", 2]))) : empty_1(), delay(() => {
            const matchValue = color;
            if (matchValue == null) {
                return empty_1();
            }
            else {
                return singleton(["color", matchValue]);
            }
        }))))),
        children: value,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function UsersPanel(users) {
    let elems_1, elems;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    return createElement(Panel, {
        title: "Brukere",
        hint: `${users.Enabled} aktive · ${users.Deactivated} deaktiverte · ${users.Pending} venter godkjenning`,
        action: createElement(LinkAction, {
            label: "Administrer →",
            href: RouterModule_encodeParts(ofArray(["admin", "bruker", "godkjenn"]), 1),
        }),
        body: createElement("div", createObj(singleton_1((elems_1 = [createElement(RoleBar, {
            roles: users.Roles,
        }), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(isMobile ? append(singleton(["flexWrap", "wrap"]), delay(() => append(singleton(["columnGap", 18 + "px"]), delay(() => singleton(["rowGap", 6 + "px"]))))) : singleton(["gap", 14 + "px "]), delay(() => append(singleton(["marginTop", 14]), delay(() => append(singleton(["paddingTop", 12]), delay(() => singleton(["borderTop", (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke3]))))))))))))], (elems = [createElement(MiniStat, {
            label: "Nye, 7 dager",
            value: `+${users.New7}`,
            color: tokens.colorBrandForeground1,
            withDivider: false,
        }), createElement(MiniStat, {
            label: "Nye, 30 dager",
            value: `+${users.New30}`,
            withDivider: true,
        }), createElement(MiniStat, {
            label: "Venter",
            value: int32ToString(users.Pending),
            color: tokens.colorPaletteMarigoldForeground1,
            withDivider: true,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])))),
    });
}

function TopTracksPanel(learning) {
    let elems_2;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    return createElement(Panel, {
        title: "Mest populære læringsløp",
        hint: `${learning.TracksEnabled} aktive løp totalt`,
        action: createElement(LinkAction, {
            label: "Alle løp →",
            href: RouterModule_encodeParts(singleton_1("laeringslop"), 1),
        }),
        body: createElement("div", createObj(singleton_1((elems_2 = ofArray(mapIndexed((i, t) => {
            let elems, el, el_2, elems_1, el_4, el_6, el_8, el_10;
            if (isMobile) {
                return createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    padding: ((10 + "px ") + 0) + "px",
                    borderBottom: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke3,
                }], (elems = [(el = Body1Strong, createElement(el, {
                    style: {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    },
                    children: `${i + 1}. ${t.Name}`,
                })), (el_2 = Caption1, createElement(el_2, {
                    style: {
                        color: tokens.colorNeutralForeground3,
                        marginTop: 2,
                    },
                    children: `${t.Enrollments} påmeldinger`,
                }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
            }
            else {
                return createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                    gap: 10 + "px ",
                    padding: ((7 + "px ") + 0) + "px",
                    borderBottom: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke3,
                }], (elems_1 = [(el_4 = Caption1Strong, createElement(el_4, {
                    style: {
                        width: 18,
                        color: tokens.colorNeutralForeground3,
                    },
                    children: int32ToString(i + 1),
                })), (el_6 = Body1, createElement(el_6, {
                    style: {
                        flexGrow: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    },
                    children: t.Name,
                })), (el_8 = Caption1, createElement(el_8, {
                    style: {
                        color: tokens.colorNeutralForeground3,
                    },
                    children: "påmeldinger",
                })), (el_10 = Body1Strong, createElement(el_10, {
                    style: {
                        color: tokens.colorBrandForeground1,
                    },
                    children: int32ToString(t.Enrollments),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
            }
        }, learning.TopTracks)), ["children", reactApi.Children.toArray(Array.from(elems_2))])))),
    });
}

function AdminOverview(adminOverviewInputProps) {
    let elems_3;
    const isMobile = adminOverviewInputProps.isMobile;
    const panel = adminOverviewInputProps.panel;
    return createElement("div", createObj(ofArray([["style", {
        marginBottom: 28,
    }], (elems_3 = toList(delay(() => append(singleton(createElement(SectionTitle, {
        title: "Administratoroversikt",
    })), delay(() => {
        let elems_1, el_4, el_6, el_8, el_10, el_2, elems, el;
        const matchValue = panel;
        if (matchValue != null) {
            const p = matchValue;
            return append(singleton(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "grid"]), delay(() => {
                let matchValue_1;
                return append((matchValue_1 = useFeliz_React__React_useResponsive_Static_Z434A9929(), (matchValue_1.tag === 0) ? singleton(["gridTemplateColumns", join(" ", [1 + "fr", 1 + "fr"])]) : ((matchValue_1.tag === 1) ? singleton(["gridTemplateColumns", join(" ", [1 + "fr", 1 + "fr"])]) : ((matchValue_1.tag === 2) ? singleton(["gridTemplateColumns", join(" ", [1 + "fr", 1 + "fr"])]) : singleton(["gridTemplateColumns", join(" ", [1 + "fr", 1 + "fr", 1 + "fr", 1 + "fr"])])))), delay(() => append(singleton(["gap", (isMobile ? 8 : 12) + "px "]), delay(() => singleton(["marginBottom", 14])))));
            })))))], (elems_1 = [createElement(AdminKpi, {
                accent: tokens.colorBrandForeground1,
                subtle: tokens.colorBrandBackground2,
                icon: (el_4 = PeopleRegular, createElement(el_4, {
                    fontSize: 20,
                })),
                label: "Aktive brukere",
                value: p.Users.Enabled,
                sub: `+${p.Users.New7} siste 7 dg`,
            }), createElement(AdminKpi, {
                accent: tokens.colorPaletteRoyalBlueForeground2,
                subtle: tokens.colorPaletteRoyalBlueBackground2,
                icon: (el_6 = BookOpenRegular, createElement(el_6, {
                    fontSize: 20,
                })),
                label: "Påmeldinger til løp",
                value: p.Learning.Enrollments,
                sub: `${p.Learning.Inactive} inaktive`,
            }), createElement(AdminKpi, {
                accent: tokens.colorPaletteMarigoldForeground1,
                subtle: tokens.colorPaletteMarigoldBackground2,
                icon: (el_8 = TaskListLtrRegular, createElement(el_8, {
                    fontSize: 20,
                })),
                label: "Oppgaver fullført",
                value: p.Learning.Tasks7,
                sub: `${p.Learning.Tasks30} siste 30 dg`,
            }), createElement(AdminKpi, {
                accent: tokens.colorPaletteBerryForeground1,
                subtle: tokens.colorPaletteBerryBackground2,
                icon: (el_10 = CalendarLtrRegular, createElement(el_10, {
                    fontSize: 20,
                })),
                label: "Kommende arrangementer",
                value: p.Events.Upcoming,
                sub: "",
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_2;
                return singleton(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "grid"]), delay(() => append(isMobile ? singleton(["gridTemplateColumns", join(" ", [1 + "fr"])]) : singleton(["gridTemplateColumns", join(" ", [1 + "fr", 1 + "fr"])]), delay(() => singleton(["gap", 12 + "px "]))))))))], (elems_2 = [createElement(UsersPanel, p.Users), createElement(TopTracksPanel, p.Learning)], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
            }));
        }
        else {
            return singleton((el_2 = Skeleton, createElement(el_2, createObj(singleton_1((elems = [(el = SkeletonItem, createElement(el, {
                style: {
                    height: 140,
                },
                shape: "rectangle",
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems))]))))));
        }
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function TrackSection(trackSectionInputProps) {
    let elems_2;
    const isMobile = trackSectionInputProps.isMobile;
    const model = trackSectionInputProps.model;
    return createElement("div", createObj(singleton_1((elems_2 = toList(delay(() => append(singleton(createElement(SectionTitle, {
        title: "Dine læringsløp",
        action: createElement(LinkAction, {
            label: "Vis alle",
            href: RouterModule_encodeParts(singleton_1("laeringslop"), 1),
        }),
    })), delay(() => {
        let el_4, elems, el, el_2, elems_1;
        return (model.UserTracks.length === 0) ? singleton((el_4 = Card, createElement(el_4, createObj(ofArray([["style", {
            padding: ((16 + "px ") + 18) + "px",
            alignItems: "center",
            gap: 8 + "px ",
        }], (elems = [(el = PeopleCommunityRegular, createElement(el, {
            primaryFill: tokens.colorBrandForeground1,
            style: {
                fontSize: 64 + "px",
            },
        })), (el_2 = Caption1, createElement(el_2, {
            children: "Du er ikke påmeldt noen læringsløp",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))) : singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 14 + "px ",
        }], (elems_1 = ofArray(map((t) => createElement(Enrolled, {
            isMobile: isMobile,
            userCompletedTasks: model.UserCompletedTasks,
            et: t,
        }), model.UserTracks)), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
}

class ActivityItem extends Record {
    constructor(Text$, When, Detail, Accent, Href) {
        super();
        this.Text = Text$;
        this.When = When;
        this.Detail = Detail;
        this.Accent = Accent;
        this.Href = Href;
    }
}

function ActivityItem_$reflection() {
    return record_type("Home.ActivityItem", [], ActivityItem, () => [["Text", string_type], ["When", class_type("System.DateTime")], ["Detail", string_type], ["Accent", string_type], ["Href", string_type]]);
}

function historicEventsHrefFor(userId) {
    return RouterModule_encodeParts(ofArray(["bruker", int32ToString(userId), "historikk"]), 1);
}

function deriveActivity(userId, model) {
    return truncate(5, map((ct) => {
        let matchValue;
        return new ActivityItem(`Fullførte «${ct.Task.Name}»`, ct.Completed, "", tokens.colorBrandForeground1, (matchValue = ct.EventId, (matchValue == null) ? historicEventsHrefFor(userId) : RouterModule_encodeParts(ofArray(["arrangement", int32ToString(matchValue)]), 1)));
    }, truncate(8, sortByDescending((_arg) => _arg.Completed, model.UserCompletedTasks, {
        Compare: compare,
    }))));
}

function ActivityRow(activityRowInputProps) {
    let elems_2, elems, elems_1, el_4, el_2, el_6;
    const isLast = activityRowInputProps.isLast;
    const item = activityRowInputProps.item;
    const timeAgo = formatTimeDiff(op_Subtraction(utcNow(), item.When));
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        gap: 12 + "px ",
        paddingBottom: isLast ? 0 : 12,
    }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexShrink: 0,
    }], (elems = toList(delay(() => {
        let el;
        return append(singleton((el = CircleFilled, createElement(el, {
            style: {
                fontSize: 12 + "px",
            },
            primaryFill: item.Accent,
        }))), delay(() => (!isLast ? singleton(customDivider(tokens.colorNeutralStroke2)) : empty_1())));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
        minWidth: 0,
    }], (elems_1 = [(el_4 = Link, createElement(el_4, {
        href: item.Href,
        children: (el_2 = Body1, createElement(el_2, {
            children: item.Text,
        })),
    })), (el_6 = Caption1, createElement(el_6, {
        style: {
            display: "block",
            color: tokens.colorNeutralForeground3,
            marginTop: 2,
        },
        children: (item.Detail.length > 0) ? (`${timeAgo} · ${item.Detail}`) : timeAgo,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function ActivitySection(activitySectionInputProps) {
    let elems_1;
    const model = activitySectionInputProps.model;
    const userId = activitySectionInputProps.userId;
    const items = deriveActivity(userId, model);
    return createElement("div", createObj(singleton_1((elems_1 = toList(delay(() => append(singleton(createElement(SectionTitle, {
        title: "Nylig aktivitet",
        action: createElement(LinkAction, {
            label: "Vis alle",
            href: historicEventsHrefFor(userId),
        }),
    })), delay(() => {
        let el, elems;
        return (items.length === 0) ? singleton((el = Caption1, createElement(el, {
            style: {
                color: tokens.colorNeutralForeground3,
            },
            children: "Ingen registrert aktivitet enda",
        }))) : singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems = ofArray(mapIndexed((i, it) => createElement(ActivityRow, {
            item: it,
            isLast: i === (items.length - 1),
        }), items)), ["children", reactApi.Children.toArray(Array.from(elems))])]))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))]))));
}

function countdownHeading(trigger, action) {
    let matchResult;
    switch (trigger.tag) {
        case 2: {
            switch (action.tag) {
                case 5: {
                    matchResult = 0;
                    break;
                }
                case 3: {
                    matchResult = 1;
                    break;
                }
                case 2: {
                    matchResult = 2;
                    break;
                }
                case 4: {
                    matchResult = 3;
                    break;
                }
                default:
                    matchResult = 4;
            }
            break;
        }
        case 5: {
            switch (action.tag) {
                case 5: {
                    matchResult = 0;
                    break;
                }
                case 3: {
                    matchResult = 1;
                    break;
                }
                case 2: {
                    matchResult = 2;
                    break;
                }
                case 4: {
                    matchResult = 3;
                    break;
                }
                default:
                    matchResult = 4;
            }
            break;
        }
        case 8: {
            switch (action.tag) {
                case 5: {
                    matchResult = 0;
                    break;
                }
                case 3: {
                    matchResult = 1;
                    break;
                }
                case 2: {
                    matchResult = 2;
                    break;
                }
                case 4: {
                    matchResult = 3;
                    break;
                }
                default:
                    matchResult = 4;
            }
            break;
        }
        case 3: {
            switch (action.tag) {
                case 5: {
                    matchResult = 0;
                    break;
                }
                case 3: {
                    matchResult = 1;
                    break;
                }
                case 2: {
                    matchResult = 2;
                    break;
                }
                case 4: {
                    matchResult = 3;
                    break;
                }
                default:
                    matchResult = 4;
            }
            break;
        }
        case 9: {
            switch (action.tag) {
                case 5: {
                    matchResult = 0;
                    break;
                }
                case 3: {
                    matchResult = 1;
                    break;
                }
                case 2: {
                    matchResult = 2;
                    break;
                }
                case 4: {
                    matchResult = 3;
                    break;
                }
                default:
                    matchResult = 4;
            }
            break;
        }
        default:
            switch (action.tag) {
                case 3: {
                    matchResult = 1;
                    break;
                }
                case 2: {
                    matchResult = 2;
                    break;
                }
                case 4: {
                    matchResult = 3;
                    break;
                }
                default:
                    matchResult = 4;
            }
    }
    switch (matchResult) {
        case 0:
            return "Mister tilgang til kursmateriale";
        case 1:
            return "Læringsløpet blir inaktivt";
        case 2:
            return "Bruker-status endres";
        case 3:
            return "Får tilgang til kursmateriale";
        default:
            return "Automatisering utløses";
    }
}

function countdownHint(trigger) {
    switch (trigger.tag) {
        case 2:
        case 5:
        case 8:
            return "Fullfør en oppgave for å nullstille telleren";
        case 9:
            return "Fullfør nivået for å forhindre dette";
        default:
            return undefined;
    }
}

function AutomationCountdownBadge(c) {
    let t_1, l, t, elems, matchValue_4, el_10, el_8;
    const daysRemaining = totalDays(op_Subtraction(c.FireDate, utcNow()));
    let absoluteDate;
    const locale = nb;
    const formatOptions = {};
    formatOptions.locale = locale;
    absoluteDate = format_1(c.FireDate, "d. MMM yyyy", formatOptions);
    let relativeLabel;
    if (daysRemaining < 0) {
        const arg = -daysRemaining;
        relativeLabel = toText(printf("%.0f dager forsinket"))(arg);
    }
    else {
        relativeLabel = ((daysRemaining < 1) ? "i dag" : toText(printf("om %.0f dager"))(daysRemaining));
    }
    const badgeColor = (daysRemaining < 0) ? ["color", "danger"] : ((daysRemaining < 14) ? ["color", "warning"] : ["color", "brand"]);
    let scope;
    const matchValue = c.TrackName;
    const matchValue_1 = c.TrackLevelName;
    scope = ((matchValue != null) ? ((matchValue_1 == null) ? ((t_1 = matchValue, t_1)) : ((l = matchValue_1, (t = matchValue, `${t} / ${l}`)))) : "");
    const label = (scope.length > 0) ? (`${relativeLabel} · ${scope}`) : relativeLabel;
    const el_13 = Tooltip;
    return createElement(el_13, createObj(ofArray([["content", createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 4 + "px ",
        maxWidth: 260,
    }], (elems = toList(delay(() => {
        let el;
        return append(singleton((el = Body1Strong, createElement(el, {
            children: countdownHeading(c.TriggerType, c.ActionType),
        }))), delay(() => {
            let el_2;
            return append(singleton((el_2 = Caption1, createElement(el_2, {
                style: {
                    color: tokens.colorNeutralForeground3,
                },
                children: `${relativeLabel} · ${absoluteDate}`,
            }))), delay(() => {
                let el_4;
                return append((scope.length > 0) ? singleton((el_4 = Caption1, createElement(el_4, {
                    style: {
                        color: tokens.colorNeutralForeground3,
                    },
                    children: scope,
                }))) : empty_1(), delay(() => {
                    let el_6;
                    const matchValue_3 = countdownHint(c.TriggerType);
                    if (matchValue_3 == null) {
                        return singleton(defaultOf());
                    }
                    else {
                        const hint = matchValue_3;
                        return singleton((el_6 = Caption1, createElement(el_6, {
                            style: {
                                color: tokens.colorNeutralForeground3,
                                fontStyle: "italic",
                            },
                            children: hint,
                        })));
                    }
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["relationship", "label"], (matchValue_4 = tryHead([(el_10 = Badge, createElement(el_10, createObj(ofArray([["appearance", "tint"], ["size", "large"], ["shape", "rounded"], badgeColor, ["icon", (el_8 = TimerRegular, createElement(el_8, {}))], ["children", label]]))))]), (matchValue_4 == null) ? ["children", defaultOf()] : ["children", matchValue_4])])));
}

function AutomationCountdownSection(model) {
    let elems_1, elems;
    const items = truncate(5, model.MyAutomationCountdowns);
    if (items.length === 0) {
        return defaultOf();
    }
    else {
        return createElement("div", createObj(singleton_1((elems_1 = [createElement(SectionTitle, {
            title: "Dine frister",
        }), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexWrap: "wrap",
            gap: 8 + "px ",
        }], (elems = ofArray(map((c) => createElement(AutomationCountdownBadge, c), items)), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))]))));
    }
}

function Promises_fetchAll(dispatch, setCtx) {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => ((Promise.all([startAsPromise(Event$.GetEnabled()), startAsPromise(Event$.GetMyUpcoming()), startAsPromise(Track.GetMy()), startAsPromise(Task.GetMyCompleted()), startAsPromise(Rule.GetMyAutomationCountdowns())])).then((_arg) => {
        let array;
        dispatch(new Msg(1, [(array = Result_DefaultValue([], _arg[0]), array.filter((e) => (compare(e.Time, utcNow()) >= 0)))]));
        dispatch(new Msg(2, [ofArray_1(map((_arg_1) => _arg_1.Id, Result_DefaultValue([], _arg[1]), Int32Array), {
            Compare: comparePrimitives,
        })]));
        dispatch(new Msg(3, [Result_DefaultValue([], _arg[2])]));
        dispatch(new Msg(4, [Result_DefaultValue([], _arg[3])]));
        dispatch(new Msg(5, [Result_DefaultValue([], _arg[4])]));
        return Promise.resolve();
    }))));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_fetchAdminPanel(dispatch, setCtx) {
    const pr = tap((_arg) => {
        if (_arg.tag === 1) {
            if (_arg.fields[0].tag === 1) {
                errorToast(setCtx, "adminPanelInternal", "Noe gikk galt", "Kunne ikke hente administratoroversikten", undefined);
            }
            else {
                errorToast(setCtx, "adminPanelUnauthorized", "Ikke tilgang", "Du har ikke tilgang til administratoroversikten", undefined);
            }
        }
        else {
            dispatch(new Msg(0, [_arg.fields[0]]));
        }
    }, startAsPromise(Home.GetAdminPanel()));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

export function View() {
    let elems_5;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = (equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []))) ? true : equals(screenSize, new ScreenSize(2, []));
    useEffectOnce(() => {
        Promises_fetchAll(dispatch, setCtx);
        if (equals(ctx.User.Role, new Role(1, []))) {
            Promises_fetchAdminPanel(dispatch, setCtx);
        }
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
        maxWidth: 100 + "%",
    }], (elems_5 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            marginBottom: 22,
        }], (elems = toList(delay(() => {
            let el, el_2;
            const greeting = `${greetingPrefix()}, ${ctx.User.FirstName} 👋`;
            const greetingProps = ofArray([["as", "h1"], ["style", {
                letterSpacing: "-0.4px",
                margin: 0,
            }], ["children", greeting]]);
            return append(isMobile ? singleton((el = Title3, createElement(el, createObj(greetingProps)))) : singleton((el_2 = Title2, createElement(el_2, createObj(greetingProps)))), delay(() => {
                let el_4;
                return singleton((el_4 = Body1, createElement(el_4, {
                    style: {
                        display: "block",
                        color: tokens.colorNeutralForeground2,
                        marginTop: 4,
                    },
                    children: "Fortsett der du slapp.",
                })));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(equals(ctx.User.Role, new Role(1, [])) ? singleton(createElement(AdminOverview, {
            panel: unwrap(model.AdminPanel),
            isMobile: isMobile,
        })) : empty_1(), delay(() => {
            let elems_4, elems_1, elems_3;
            return singleton(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "grid"]), delay(() => append(isMobile ? singleton(["gridTemplateColumns", join(" ", [1 + "fr"])]) : singleton(["gridTemplateColumns", join(" ", [1 + "fr", 320 + "px"])]), delay(() => singleton(["gap", 24 + "px "]))))))))], (elems_4 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 24 + "px ",
                minWidth: 0,
            }], (elems_1 = [createElement(TrackSection, {
                model: model,
                isMobile: isMobile,
            }), createElement(AgendaSection, {
                currentUser: ctx.User,
                attendedIds: model.AttendedEventIds,
                events: model.UpcomingEvents,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 24 + "px ",
                minWidth: 0,
            }], (elems_3 = toList(delay(() => append(singleton(createElement(AutomationCountdownSection, model)), delay(() => append(singleton(createElement(ActivitySection, {
                userId: ctx.User.Id,
                model: model,
            })), delay(() => {
                let elems_2;
                return !isMobile ? singleton(createElement("div", createObj(singleton_1((elems_2 = [createElement(SectionTitle, {
                    title: "Varsler",
                }), createElement(NotificationListInline, {
                    max: 5,
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))]))))) : empty_1();
            })))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

//# sourceMappingURL=Home.jsx.map
